import { render, staticRenderFns } from "./BookingNote.vue?vue&type=template&id=2e398788"
import script from "./BookingNote.vue?vue&type=script&lang=js"
export * from "./BookingNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports